import { useContactsContext } from '@/contexts/contacts/context';
import { SplitterMsgData } from '../messages/type';
// import PlaceholderIcon from './components/contacts-bar/svg/placeholder.svg?react';
// import LockIcon from './components/contacts-bar/svg/lock.svg?react';
// import Category from './components/category';
import ContactsBar from './components/contacts-bar';
// import Header from './components/header';
import styles from './index.module.scss';

const Contacts: React.FC = () => {
  const { contacts } = useContactsContext();

  return (
    <div className={styles.contacts}>
      <Splitter className={styles.splitter}>
        <Splitter.Panel
          defaultSize={SplitterMsgData.DEFAULT_SIZE_AND_MIN}
          min={SplitterMsgData.SIZE}
        >
          <div className={styles.contactsBox}>
            {/* <Header /> */}
            {/* <Category /> */}
            <ContactsBar contacts={contacts} />
          </div>
        </Splitter.Panel>
        <Splitter.Panel min={SplitterMsgData.SIZE}>
          <div className={styles.content}>
            <div className={styles.placeholder}>
              <div className={cls(styles.placeholderTextTitle, styles.bg)}>
                Add contacts to start messaging
              </div>
              {/* <div className={styles.placeholderIcon}>
                <PlaceholderIcon />
              </div>
              <div className={styles.placeholderText}>
                <LockIcon />
                <div className={styles.placeholderTextTitle}>
                  Your messages are{' '}
                  <span className={styles.tip}>end-to-end encrypted</span>
                </div>
              </div> */}
            </div>
          </div>
        </Splitter.Panel>
      </Splitter>
    </div>
  );
};

export default Contacts;
